export default __webpack_public_path__ + "static/iPhoneX-68a47a865c643beaf2112f32693f6762.png";